import { importProvidersFrom } from '@angular/core';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, Routes } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authHeaderInterceptor } from './app/shared/interceptors/auth-header.interceptor';
import { DashboardComponent } from './app/components/dashboard/dashboard.component';
import { AuthGuard } from './app/guards/auth.guard';
import { TribesComponent } from './app/pages/tribes/tribes.component';
import { LearningZoneComponent } from './app/pages/learning-zone/learning-zone.component';
import { CertificatesComponent } from './app/pages/certificates/certificates.component';
import { CoursesComponent } from './app/pages/courses/courses.component';
import { ConfigurationComponent } from './app/pages/configuration/configuration.component';
import { GradesComponent } from './app/pages/grades/grades.component';
import { CourseComponent } from './app/pages/course/course.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IsAuthGuard } from './app/guards/is-auth.guard';
import { CourseGuard } from './app/guards/course.guard';
import { FormGuard } from './app/guards/form.guard';
import { NotificationsComponent } from './app/pages/notifications/notifications.component';

const edutegiaRoutes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    canActivate: [AuthGuard], // Protege la ruta del dashboard con el guard AuthGuard
    children: [
      // Rutas dentro del dashboard
      { path: '', redirectTo: 'zona-de-aprendizaje', pathMatch: 'full'},
      { path: 'zona-de-aprendizaje', component: LearningZoneComponent },
      { path: 'cursos', component: CoursesComponent,
        children:[
          { path: '', component: CoursesComponent},
        ]
      },
      { path: 'cursos/:course-name', component: CourseComponent,
      canActivate: [CourseGuard],
        loadChildren: () =>
          import('./app/pages/courses/courses.routes').then
          (mod => mod.CoursesRoutes)
      },
      { path: 'tribus', component: TribesComponent },
      { path: 'calificaciones', component: GradesComponent },
      { path: 'certificados', component:  CertificatesComponent},
      { path: 'notificaciones', component: NotificationsComponent },
      { path: 'configuración', component: ConfigurationComponent,
      canDeactivate: [FormGuard] },
      // { path: 'activity', component: ActivityComponent},
      // { path: '**', redirectTo: 'tribes' }, HACER EL COMPONENTE 404
    ],
  },
  {
    path: 'registro',
    loadComponent: () =>
      import('./app/pages/register/register.component').then(
        (mod) => mod.RegisterComponent
      ),
    canActivate: [IsAuthGuard]
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./app/pages/login/login.component').then(
        (mod) => mod.LoginComponent
      ),
    canActivate: [IsAuthGuard]
  },
  {
    path: 'recuperacion-contraseña',
    loadComponent: () =>
      import('./app/pages/reset-password/reset-password.component').then(
        (mod) => mod.ResetPasswordComponent
      ),
      canActivate: [IsAuthGuard]
  },
  {
    path: 'nueva-contrasena',
    loadComponent: () =>
      import('./app/pages/new-password/new-password.component').then(
        (mod) => mod.NewPasswordComponent
      ),
      canActivate: [IsAuthGuard]
  },
  // {
  //   path: 'about',
  //   loadComponent: () =>
  //     import('./app/pages/about/about.component').then(
  //       (mod) => mod.AboutComponent
  //     ),
  // },
  {
    path: '**',
    redirectTo: 'login',
    pathMatch: 'full'
  }, // Redirigir al inicio de sesión por defecto
];

bootstrapApplication(
  AppComponent,
  {
    providers: [
    // importProvidersFrom(BrowserModule),
    provideHttpClient(withInterceptors([authHeaderInterceptor])),
    provideRouter(edutegiaRoutes),
    importProvidersFrom(BrowserAnimationsModule)
],
  }
  ).catch((err) => console.error(`Edutegia got a error: ${err}, contact the administrator.`));
